import React, {Component} from 'react';
import { Row, Table, Button, Col } from 'antd';
import NewUser from './NewUser';

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {},
            modalVisibility: false
        }
    }
    componentDidMount() {

    }
    handleTableChange(pagination) {
        const {fetchUsers} = this.props;
        const {current} = pagination;
        // return fetchUsers(current).then(() => {
        //     this.setState({pagination: {...this.state.pagination, current}});
        // });
    }
    render() {
        const loading = false;
        const users = [];
        const columns = [{
            title: 'Name',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: 'Address Line 1',
            dataIndex: 'address_line_1',
            key: 'address_line_1'
        }, {
            title: 'Address Line 2',
            dataIndex: 'address_line_2',
            key: 'address_line_2'
        }, {
            title: 'Address Line 3',
            dataIndex: 'address_line_3',
            key: 'address_line_3'
        }, {
            title: 'Postcode',
            dataIndex: 'post_code',
            key: 'post_code'
        }, {
            title: 'Contact Tel.',
            dataIndex: 'phone_number',
            key: 'phone_number'
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email'
        }, {
            title: '',
            key: 'view',
            render: (text, record) => (
                <span>
                <a href="#">View</a>
                </span>
            )
        }];

        const showCreateUser = () => {
            const {pagination} = this.state;
            this.setState({
                pagination,
                modalVisibility: true
            });
        };

        const onCreate = () => {
            this.setState({
                modalVisibility: false
            });
        };

        return (
            <div>
                <NewUser visible={this.state.modalVisibility} onOk={onCreate} onCancel={onCreate}/>
                <Row style={{marginBottom: 16}}>
                    <Col span={24}>
                        <Button style={{float: 'right'}} onClick={showCreateUser}>Create</Button>
                    </Col>
                </Row>
                <Table
                    columns={columns}
                    dataSource={users}
                    loading={loading}
                    pagination={this.state.pagination}
                    rowKey={record => record.id}
                    size="middle"
                    onChange={this.handleTableChange.bind(this)}
                />
            </div>
        )
    }
}

export default Users;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Users.js